import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from "@angular/forms";
import {ModalController} from "@ionic/angular";
import {Bonus, BonusStatus, BonusType, Contract, PermissionType, User} from "../../../models";
import {DataStore} from "@aws-amplify/datastore";
import {ContractStatus} from "../../enums/enums";

@Component({
    selector: 'app-edit-payment',
    templateUrl: './edit-payment.component.html',
    styleUrls: ['./edit-payment.component.scss'],
})
export class EditPaymentComponent implements OnInit {
    @Input() id: string;
    public saveContractButtonText = 'Update';
    public paymentForm: UntypedFormGroup;
    public b: Bonus
    public currentBonus: any;
    public commerciali=[];
    public bonusType = BonusType;
    public bonusStatus =BonusStatus;
    public bonusStatusList: string[];
    public bonusTypeList: string[];

    constructor(public fb: UntypedFormBuilder, public modalController: ModalController,) {
        this.paymentForm = this.fb.group({
            'total': [''],
            'status': [''],
            'typeEnum': [''],
            'type': [''],
            'user': [''],
            'payDate':[''],
            'date':['']
        });
    }

    async ngOnInit() {

        if (!this.id) this.saveContractButtonText = 'Create';
        this.currentBonus = this.id ? await DataStore.query(Bonus, this.id) : new Bonus({});
        
        this.commerciali = await DataStore.query(User, u => u.or(x => x.permessions('eq', PermissionType.COMMERCIAL).permessions('eq', PermissionType.ADMINISTRATOR)));
        this.paymentForm.setControl('total', new UntypedFormControl(this.currentBonus?.total));
        this.paymentForm.setControl('payDate', new UntypedFormControl(this.currentBonus?.payDate));
        this.paymentForm.setControl('date', new UntypedFormControl(this.currentBonus?.date));
        this.paymentForm.setControl('status', new UntypedFormControl(this.currentBonus?.status));
        this.paymentForm.setControl('typeEnum', new UntypedFormControl(this.currentBonus?.typeEnum));
        this.paymentForm.setControl('type', new UntypedFormControl(this.currentBonus?.type));
        this.paymentForm.setControl('user', new UntypedFormControl(this.currentBonus?.user));
        document.querySelectorAll('.main-content')[document.querySelectorAll('.main-content').length - 1].shadowRoot.querySelector('.inner-scroll').setAttribute('style', 'height:100%');

        this.bonusStatusList = (Object.values(this.bonusStatus)).filter(x => {
            return x;
        });
        this.bonusTypeList = (Object.values(this.bonusType)).filter(x => {
            return x
        });
        
    }


    async savePayment() {
        if (this.currentBonus) {
            await this.updateBonus();

        } else {
            const savedContract = await this.createBonus();

        }

        this.modalController.dismiss();
    };


    compareWith(o1: User, o2: User) {
        return o1.id === o2.id;
    }

    private async updateBonus() {
        await DataStore.save(Bonus.copyOf(this.currentBonus,u  =>{
            u.payDate = this.paymentForm.value.payDate;
            u.type = this.paymentForm.value.payDate;
            u.status = this.paymentForm.value.status;
            u.user = this.paymentForm.value.user;
            u.typeEnum = this.paymentForm.value.typeEnum;
            u.total = parseFloat(this.paymentForm.value.total);
            u.date = this.paymentForm.value.date;
        }))

    }

    private async createBonus() {

    }
}
